import { JSXElementConstructor, ReactElement, ReactNode, useEffect, useState } from "react";

import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import config from "../../Api/config";
import { useSession } from "../sessionProvider";
import { toast } from "react-toastify";
import VariantReward from "./VariantReward";
import { DatabaseManufacturer, DatabaseOwnerEntry } from "../../Api/Database";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/scss/image-gallery.scss";
import { DragDropContext, DragStart, Draggable, DraggableProvidedDragHandleProps, DropResult, Droppable, ResponderProvided, SensorAPI } from "react-beautiful-dnd";
import API from "../../Api/api";
import DndList from "../dragNDropList";

let serverUrl = window.location.origin;

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `2px solid rgba(0, 0, 0, 0.03)`,
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  }));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "2px solid rgba(0, 0, 0, 0.03)",
  }));

export interface VariantAccordionProps {
    data: any
    dragAndDropIconProps?: any
    //delete: () => Promise<boolean>
}

export default function VariantAccordion(props: VariantAccordionProps) {

    const { ownerId } = useSession();
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const [variant, setVariantData] = useState<any>({});
    const [images, setImages] = useState<any>([]);
    const notifySuccess = (text:any) => toast.success(text,{theme:"colored"});
    const notifyError = (err:any) => toast.error(err,{theme:"colored"});

    const [brandData, setBrandData] = useState<DatabaseManufacturer>({
        name: "",
        website_url : "",
        summary :"",
        location:"",
        location_iso:"",
        business_registry_info :"",
        eori:"",
        logo:"",
    });

    useEffect(() => {
        config.API.getOwner(ownerId).then(brand => {
            setBrandData({...brand});
        }).catch(error => {
            console.error("Error in get owner API: ", error);
            notifyError("Error in get owner API: " + error);
        });
    }, []);

    const handleChange = () => () => {
        setExpanded(!expanded);
     
        config.API.getProduct(props.data.id).then((item) => {
            setVariantData(item);
            transformImg(item.image_gallery);
        }).catch(error => {
            console.error("Error in API for product: ", error);
            //notifyError("Error: " + error);
        });
    };

    async function deleteProduct(id?: string): Promise<boolean> {
        if(id) {
            /*const index = products.findIndex((product) => {
                return product.id === id;
            })*/
            let delitedName = variant.title;

            try {
                const deleted = await config.API.deleteProduct(ownerId, id);
                if(deleted) {
                    // successfully deleted on API, delete in state
                    notifySuccess("Removed product '"+ delitedName +"'.");
                }
                return deleted;
            } catch (error) {
                if(JSON.stringify(error).includes("fk__item_product_id")){
                    notifyError("Can't delete product that have DPPs registered on.");
                }else{
                    notifyError(JSON.stringify(error));
                }
            }
            
        }
        return false;
    }  

    function transformImg(images:any){
        let imgGallery:any[] = [];
        images.forEach((element:any) => {
            imgGallery.push({
                original: element,
                thumbnail: element,
            })
        });
        setImages(imgGallery);
    }

    function linkExtract(link:string){

        let cleanLink= link;

        if(cleanLink.includes("://")){
            cleanLink= cleanLink.split("://")[1];
        }

        if(cleanLink.includes("www.")){
            cleanLink= cleanLink.split("www.")[1];
        }

        if(cleanLink.includes("/")){
            cleanLink= cleanLink.split("/")[0];
        }
        
        return cleanLink;
    }

    function setVariantAwards(awards: any) {
        // Update localy
        setVariantData((o: any) => {
            let newVariant = {...o};
            newVariant.awards = awards;
            
            // Update database
            config.API.editProduct(ownerId, variant.id, newVariant).then((edited) => {
                if(edited) {
                    // Feedback something happned
                    var div2 = document.getElementById("saved_order_"+variant.id);
                    if(div2 !== null){
                        div2.className="show";
                        setTimeout(function() {
                            if(div2 !== null){
                                div2.className="hide";
                            }
                        }, 3000);
                    }
                }
            })
            return newVariant
        })
    }

    return (
        <Accordion
            expanded={expanded}
            onChange={handleChange()}
            key={"credential_info_" + props.data.id}
            sx={{ width: "100%" , backgroundColor:"gainsboro" ,marginTop:"15px !important",textOverflow: "ellipsis", overflow: "hidden"}}
            id={"credential_info_" + props.data.id}
            
        >
            <MuiAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ minHeight: "38px",textOverflow: "ellipsis", overflow: "hidden" }}
            >
               {props.dragAndDropIconProps && <div {...props.dragAndDropIconProps} style={{minWidth:"10px", height:"16px",paddingRight:"10px",margin:"auto 0"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"/></svg>
                </div>}
                
            <Typography sx={{ fontSize: "16px", fontWeight: "550",textOverflow: "ellipsis", overflow: "hidden" }}>
                {props.data.title}
            </Typography>
            </MuiAccordionSummary>
            <AccordionDetails  
            sx={{ backgroundColor:"white"}}>
                <div>
                {Object.keys(variant).length !== 0 && <>
                    <div className="product-details"> 
                
                    <h2 className="sub-title">PRODUCT ID: </h2> <p>{variant.id}</p>
                    <h2 className="sub-title">PRODUCT NAME: </h2> <p>{variant.title}</p>
                    <h2 className="sub-title">PRODUCT DESCRIPTION: </h2> <p>{variant.description}</p>
                    {variant.price !== null && (<><h2 className="sub-title">PRODUCT PRICE: </h2> <p>{variant.price.toFixed(2)} $</p></>)}
                    
                    <h2 className="sub-title">THUMBNAIL: </h2>
                    <img src={variant.thumbnail} alt={variant.title} height="auto" width="150px"    
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src="../img/no-img.png";
                    }}/>
                    <h2 className="sub-title">PRODUCT PICTURES GALLERY: </h2>
                    {/*<p>{variant.image_gallery != "" ? <a href={variant.image_gallery} target={"_blank"}>{variant.image_gallery}</a> : "N/A"}</p>*/}
                    {/*images.length > 0 &&
                        <ImageGallery items={images} showFullscreenButton={false} showPlayButton={false} showThumbnails={false}/>
                    */}

                    <ImageGallery items={images} showFullscreenButton={false} showPlayButton={false} showThumbnails={false}/>

                    <h2 className="sub-title">SAP PRODUCT CODE: </h2><p>{variant.sap_product_code != "" ? variant.sap_product_code : "N/A"}</p>    
                    <h2 className="sub-title">ADDITIONAL PRODUCT INFO: </h2>
                    <ul className="bullet-list">
                        {variant.user_manual.product_presentation !== '' && <li><a href={variant.user_manual.product_presentation}>Product presentation</a></li>}
                        {variant.user_manual.video_presentation !== '' && <li><a href={variant.user_manual.video_presentation}>Video presentation</a></li>}
                        {variant.user_manual.user_manual !== '' && <li><a href={variant.user_manual.user_manual}>User manual</a></li>}
                        {/*variant.user_manual.cleaning_instructions !== '' && <li><a href={variant.user_manual.cleaning_instructions}>Cleaning instructions</a></li>*/}
                        {variant.user_manual.product_presentation === '' && variant.user_manual.video_presentation === '' && variant.user_manual.user_manual === ''/* && variant.user_manual.cleaning_instructions === ''*/ && <>
                        <li>N/A</li>
                        </> }
                    </ul>
                    <h2 className="sub-title">SUSTAINABILITY INFO: </h2>  
                    <ul className="bullet-list">
                        <li>CO2 footprint: {variant.sustainability.co2_imprint != "" ? variant.sustainability.co2_imprint : "N/A"}</li>
                        <li>Recycle share (post consumer): {variant.sustainability.recyclate_share_post_consumer != "" ? variant.sustainability.recyclate_share_post_consumer : "N/A"}</li>
                        <li>Recycle share (post industrial): {variant.sustainability.recyclate_share_post_industrial != "" ? variant.sustainability.recyclate_share_post_industrial : "N/A"}</li>

                        <li>Recycled material share: {variant.sustainability.recyclate_material_share != "" ? variant.sustainability.recyclate_material_share : "N/A"}</li>
                        <li>Recycled material type: {variant.sustainability.recyclate_material_type != "" ? variant.sustainability.recyclate_material_type : "N/A"}</li>

                        <li>Ways of recycling: <a href={variant.sustainability.ways_of_recycling != "" ? variant.sustainability.ways_of_recycling : "N/A"} target={"_blank"}>{ variant.sustainability.ways_of_recycling != "" ? "See recycling plan" : "N/A"}</a></li>
                        <li>Discharge percentage: {variant.sustainability.discharge_percentage != "" ? variant.sustainability.discharge_percentage : "N/A"}</li>
                    </ul>
                    <h2 className="sub-title">AWARDS:<span id={"saved_order_"+variant.id} className="awards_span hide">Saved new award order</span> </h2>
                    <div className="flex-container">
                        <div className="row">
                            {variant.awards && <DndList id={variant.id} list={variant.awards} onChange={(awards: any[]) => {
                                setVariantAwards(awards);
                            }}>{(value: any, index: number, dragProps?: DraggableProvidedDragHandleProps) => {
                                return (
                                    <VariantReward key={"awards_"+index} data={value} num={index} showEmpty={true} dragAndDropIconProps={dragProps}/>
                                )
                            }}</DndList>}
                            
                            {/* Old way
                            <DragDropContext onDragEnd={(result: DropResult, provided: ResponderProvided) => {
                                console.log(result);
                                if(result.destination && result.destination.index != result.source.index) {    
                                    getChangedPos(result.source.index, result.destination.index)
                                }
                            }}>
                                <Droppable droppableId={variant.id + "drop-list"}>
                                    {(provided, snapshot) => {
                                        
                                        return (
                                            <div key={"award_droppable_list_" + variant.id} ref={provided.innerRef} style={{backgroundColor:snapshot.isDraggingOver ? 'white' : 'white', width:"100%", border:"1px solid black"}} {...provided.droppableProps}>
                                                {provided.placeholder}
                                                {variant.awards ? variant.awards.map((award: { title: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | null | undefined; url: string | undefined;}, index:any ) => {
                                                    return (
                                                        <Draggable draggableId={"awards_" + index} index={index}>
                                                            {(dragProvided, dragSnap) => {
                                                                return (    
                                                                    <div ref={dragProvided.innerRef} {...dragProvided.draggableProps} {...dragProvided.dragHandleProps}>
                                                                        <VariantReward key={"awards_"+index} data={award} num={index}  showEmpty={true}/>
                                                                    </div>
                                                                )
                                                            }}
                                                        </Draggable>
                                                    )
                                                }): <>No more data</>}
                                            </div>
                                        )
                                    }}
                                </Droppable >
                            </DragDropContext>
                            */}
                        </div>
                    </div>

                    <h2 className="sub-title">SHOP LINK: </h2>
                    <p>{variant.shop_url != "" ? variant.shop_url : "N/A"}</p>    

                    <h2 className="sub-title">COMPANY: </h2>
                    <p>{brandData.name != "" && brandData.website_url != "" ? <>{brandData.name +" | "} <a href={brandData.website_url} target='_blank'>{linkExtract(brandData.website_url)}</a> </> : "N/A" }</p>    

                    <h2 className="sub-title">COMPANY LOCATION: </h2>
                    <p>{brandData.location != "" ? brandData.location : "N/A"}</p>    


                    {
                    /*<ul className="bullet-list">
                        {variant.awards?.map((award: { title: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | null | undefined; url: string | undefined; }) => {
                            console.log(award);
                            return (
                                <li key={variant.id + "_award_" + award.title}><a href={award.url}>{award.title}</a></li>
                            )
                        })}

                        {variant.awards.length === 0 &&  <li>N/A</li> }
                    </ul>
                    <h2>CREATED DPPS: </h2>
                    <ul className="bullet-list">
                        { <li><a href={ serverUrl + "/dpps?id="+variant.id} >See DPP list</a></li> }
                    </ul> 
                    */}

                    <h2>CREATED DPPS: </h2>
                    <ul className="bullet-list">
                        { <li><a href={ serverUrl + "/dpps?id="+variant.id} >See DPP list</a></li> }
                    </ul> 

                </div>
                <div style={{paddingBottom:"19px"}}>
                    <button className="form_btn" onClick={() => {
                        deleteProduct(variant.id).then(deleted => {
                            if(deleted) {
                                setExpanded(false);
                                document.getElementById("credential_info_" + variant.id)?.remove();
                            }
                        })
                    }}>Delete</button>
                                       
                    <button className="form_btn" onClick={() => {
                        //navigate('/edit/product/' + variant.id);
                        navigate('/edit/variant/' + variant.id);
                        
                    }}>Edit</button>

                    <button className="form_btn" onClick={() => {
                        navigate('/register/item/?SAPCode='+ variant.sap_product_code+'&productID=' + variant.id );
                    }} >Create dpp</button>

                </div>    
                </>}
             </div>
            </AccordionDetails>
        </Accordion>
    )
}